import { fetchDataByAsset } from './fetchDataByAsset';
import { aiDashboardAssets } from '../configs/constants';
import api from '../api';

const { getCancelToken } = api.buildRequestCancelation();

export const fetchTimeSpentPenetration =
  (nextFilters = {}) =>
  (dispatch, getState) => {
    const { aiDashboard } = getState();
    const { filters } = aiDashboard[aiDashboardAssets.timeSpentPenetration];

    const requestFilters = {
      ...filters,
      ...nextFilters,
    };

    dispatch(
      fetchDataByAsset(aiDashboardAssets.timeSpentPenetration, requestFilters, {
        cancelToken: getCancelToken('timeSpentPenetration').token,
        transformResponse: (data) => ({ data: data?.all_users || {} }),
        decorateRequestAction: (action) => ({
          ...action,
          filters: requestFilters,
        }),
      })
    );
  };
